import { SVGProps, Ref, forwardRef } from 'react';

export const MicCrossedFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.913 11.997c-.173 1.553-.618 2.822-1.26 3.844l-1.317-1.316c.36-.678.631-1.509.765-2.528zm-3.876 6.313 4.69 4.69L23 21.728 2.273 1.004 1 2.276 6.995 8.27v2.727c0 3.749 2.5 4.999 5 4.999.795 0 1.591-.127 2.306-.42l1.397 1.395c-1.072.489-2.342.724-3.703.724-1.983 0-3.772-.499-5.035-1.551-.983-.82-1.803-2.104-2.072-4.147H3.076c.577 5.181 4.188 7.201 8.019 7.467v1.73H6.94v1.8h10v-1.8h-4.045v-1.73c1.465-.102 2.898-.46 4.142-1.154m-.043-7.313c0 .732-.095 1.368-.267 1.919L7.43 3.622C8.254 1.699 10.124 1 11.995 1c2.5 0 4.999 1.25 4.999 4.999z"
                fill="currentColor"
            />
        </g>
    </svg>
));
MicCrossedFilledSize24Glyph.displayName = 'MicCrossedFilledSize24Glyph';
